module.exports = __webpack_public_path__ + "img/big_1_51.d8bb94b2.png";